/* Tiroir MoonBundle (Nesolvia) — ligne des bijoux à initiales (NORTH) façon Maxxim : une ligne « Libellé : valeur » par choix
   (Bracelet color, Charm color, Number of initials, puis chaque initiale), libellé en gras, le tout en gris.
   Le script du tiroir (customJs MoonBundle, bijoux-miravel/cart/moonbundle/custom.js) ne garde que couleur / taille US / pierres
   dans son encadré .nsn-mvx : pour ces lignes on le masque et on pose notre liste, lue dans les propriétés de ligne cachées.
   Chargé par layout/theme.liquid. */
(function(){
  if (window.__nsnMvLines) return; window.__nsnMvLines = 1;
  function txt(el){ return el ? el.textContent.replace(/ /g, ' ').trim() : ''; }
  function esc(s){ return s.replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function run(){
    document.querySelectorAll('.moonbundle-cart-drawer-content .moonbundle-cart-item').forEach(function(it){
      var props = [], ini = [];
      it.querySelectorAll('.moonbundle-cart-item-property').forEach(function(p){
        var k = txt(p.querySelector('.moonbundle-cart-item-property-key')).replace(/\s*:$/, ''), v = txt(p.querySelector('.moonbundle-cart-item-property-value'));
        if (!k || !v || k.charAt(0) === '_') return;
        props.push([k, v]); if (/^initial/i.test(k)) ini.push(k);
      });
      var old = it.querySelector('.nsn-mvl');
      if (!ini.length) { if (old) old.remove(); it.classList.remove('nsn-mvl-on'); return; }
      // ordre Maxxim : couleur, charm, nombre d'initiales (variante), puis les initiales
      var opt = txt(it.querySelector('.moonbundle-product-options-values')).split(',').map(function(s){ return s.trim(); });
      var get = function(k){ var x = props.filter(function(p){ return p[0] === k; })[0]; return x && x[1]; };
      var rows = [['Bracelet color', get('Bracelet color') || opt[0]], ['Charm color', get('Charm color') || opt[1]], ['Number of initials', opt[2]]]
        .filter(function(r){ return r[1]; })
        .concat(props.filter(function(p){ return /^initial/i.test(p[0]); }));
      var html = rows.map(function(r){ return '<div><b>' + esc(r[0]) + ':</b> ' + esc(r[1]) + '</div>'; }).join('');
      if (old && old.dataset.sig === html) return;
      if (!old) { old = document.createElement('div'); old.className = 'nsn-mvl'; var t = it.querySelector('.moonbundle-cart-item-title'); t && t.parentNode.insertBefore(old, t.nextSibling); }
      old.dataset.sig = html; old.innerHTML = html; it.classList.add('nsn-mvl-on');
    });
  }
  var st = document.createElement('style');
  st.textContent = '.nsn-mvl-on .nsn-mvx{display:none !important}' +
    '.nsn-mvl{margin:4px 0 10px;font-size:13px;line-height:1.35;color:#8f8f8f;letter-spacing:.01em}' +
    '.nsn-mvl b{font-weight:600;color:#8f8f8f}';
  document.head.appendChild(st);
  var busy = false;
  new MutationObserver(function(){ if (busy) return; busy = true; requestAnimationFrame(function(){ try { run(); } finally { busy = false; } }); })
    .observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
